<template>
  <span :class="labelClass">{{text}}</span>
</template>

<script>
  export default {
    props: {
      bpsChange: {
        required: true
      },
      text: {
        required: true
      }
    },
    computed: {
      labelClass() {
        if (this.bpsChange === 'NaN' || this.bpsChange === 0.0) {
          return 'neutral';
        } else if (this.bpsChange > 0.0) {
          return 'positive';
        } else if (this.bpsChange < 0.0) {
          return 'negative';
        }
      }
    }
  }
</script>


